import Flickity from 'flickity';
import HeroComponent from '../components/hero';
import YouTubeEmbedAPI from '../modules/YouTubeEmbedAPI';

export default class WelfareController {

  constructor(options) {
    this.options = options;
    console.log('WELFARE CONTROLLER');

    this.welfare_hero = new HeroComponent({
      elem      :'section.welfare__hero',
      parallaxCopy : true,
    });

    this.welfare_vtour = new HeroComponent({
      elem      :'section.welfare__vtour',
    });

    this.ourfarms_hero = new HeroComponent({
      elem      :'section.ourfarms__farmers',
    });

    this.truck = new HeroComponent({
      elem      :'section.truck',
    });

    // ** NOTE: if we allow for more than one gallery, we would
    // iterate over the .blog__gallery elems and start a
    // flickity for each one. **

    if ( $('div.welfare__gallery')[0] ) {
      this.flkty = new Flickity('div.welfare__gallery', {
        prevNextButtons: true,
        wrapAround: true,
        arrowShape: 'M71.09,7a6.62,6.62,0,0,1,4.82,11.14L47.24,48.69,76.37,82a6.62,6.62,0,0,1-10,8.71l-37-42.37L66.27,9.09A6.6,6.6,0,0,1,71.09,7Z',
      });

      if (this.flkty.cells.length < 1) {
        this.flkty.destroy();
        this.flkty = new Flickity('div.welfare__gallery', {
          prevNextButtons: false,
          wrapAround: false,
        });
      }
    }

    if ( $('div.related__gallery')[0] ) {
      this.flkty = new Flickity('div.related__gallery', {
        prevNextButtons: true,
        wrapAround: true,
        arrowShape: 'M71.09,7a6.62,6.62,0,0,1,4.82,11.14L47.24,48.69,76.37,82a6.62,6.62,0,0,1-10,8.71l-37-42.37L66.27,9.09A6.6,6.6,0,0,1,71.09,7Z',
      });

      if (this.flkty.cells.length < 1) {
        this.flkty.destroy();
        this.flkty = new Flickity('div.related__gallery', {
          prevNextButtons: false,
          wrapAround: false,
        });
      }
    }

    this.YTE = new YouTubeEmbedAPI();

    $('.is-video').click( (e) => {
      e.preventDefault();

      $('div.site__overlay').addClass('is-active');
      $('div.modal').addClass('is-active');

      const videoID = $(e.currentTarget).data('videoid');
      console.log(videoID, $(e.currentTarget));
      this.YTE.createPlayer(videoID);
    });


    $('div.modal').click( (e) => {

      if ( $(e.target).hasClass('modal') ||
        $(e.target).hasClass('modal__close') ) {

        $('div.site__overlay').removeClass('is-active');
        $('div.modal').removeClass('is-active');

        if (this.YTE) {
          this.YTE.destroyPlayer();
        }
      }

    });

    $('nav.siteNav__main>div>a.submenu__csr').addClass('is-activepage');

    this.transitionIn();

  }

  transitionIn() {
    // reveal the home hero text
    $('.welfare__hero .cmpnt__hero__copy__cntr').addClass('do-intro');

    setTimeout( () => {
      $('.welfare__hero .cmpnt__hero__copy__cntr').removeClass('do-intro start-intro');
    }, 2300);

  }

}



// WEBPACK FOOTER //
// ./js/controllers/pages/WelfareController.js